import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Header from "../../components/header/Header";
import TherapistPassword from "../../components/therapistpassword/TherapistPassword";
import TherapistRegisterData from "../../components/therapistregisterdata/TherapistRegisterData";
import Monitoring from "../../components/monitoring/Monitoring";
import Appointments from "../../components/appointments/Appointments";
import Menu from "../../components/menu/Menu";

const TherapistRegister = (props) => {
  const [ptRegStep, setPtRegStep] = useState(1);
  let { firstName } = useParams();
  let { lastName } = useParams();
  let { email } = useParams();
  let { businessId } = useParams();

  useEffect(() => {
    axios
      .post(window.ajaxLink + "cloud_therapist/getNewPtRegisterData", { firstName, lastName, email, businessId })
      .then((res) => {
        if (res.data.responseData) {
          localStorage.setItem("new_pt_reg_data", JSON.stringify(res.data.responseData));
        }
      })
      .catch((error) => {
        console.error(error);
      });
      // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (ptRegStep === 3) {
      props.actSidebar(true);
    }
  }, [props, ptRegStep]);

  return (
    <>
      {ptRegStep !== 3 && <Header />}
      <div className={"memberRegisterContainer patientLoginContainer " + (ptRegStep !== 1 ? "ptLoginExpand" : "")}>
        {ptRegStep === 1 ? (
          <TherapistPassword setPtRegStep={setPtRegStep} />
        ) : ptRegStep === 2 ? (
          <TherapistRegisterData setPtRegStep={setPtRegStep} props={props} />
        ) : ptRegStep === 3 ? (
          <div>
            <Menu title={"Dashboard"} checkLoggedIn={props.checkLoggedIn} />
            <div className="dash_info_hold">
              <Appointments checkLoggedIn={props.checkLoggedIn} />
              <Monitoring checkLoggedIn={props.checkLoggedIn} />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default TherapistRegister;
